import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactHero from './components/ContactHero';
import ContactChannels from './components/ContactChannels';
import ContactForm from './components/ContactForm';
import FAQSection from './components/FAQSection';
import ResourceCenter from './components/ResourceCenter';
import SupportStats from './components/SupportStats';
import LocationInfo from './components/LocationInfo';

const ContactSupport = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16 lg:pt-20">
        <ContactHero />
        <ContactChannels />
        <SupportStats />
        <ContactForm />
        <FAQSection />
        <ResourceCenter />
        <LocationInfo />
      </main>

      <Footer />
    </div>
  );
};

export default ContactSupport;